"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class OfferWithEstimatesProduct extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ description: 'The product id', example: 'E_H_BDZ' }),
    tslib_1.__metadata("design:type", String)
], OfferWithEstimatesProduct.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'The product description',
        example: 'ZekerheidsGarantie Elektriciteit Groen',
    }),
    tslib_1.__metadata("design:type", String)
], OfferWithEstimatesProduct.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.EnergyType)),
    (0, base_models_1.Docs)({
        description: 'Enerty type of the product',
        example: base_models_1.EnergyType.ELECTRICITY,
    }),
    tslib_1.__metadata("design:type", String)
], OfferWithEstimatesProduct.prototype, "energyType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        description: 'The duration in years of the product',
        example: base_models_1.DurationInYears.FIVE,
    }),
    tslib_1.__metadata("design:type", String)
], OfferWithEstimatesProduct.prototype, "durationInYears", void 0);
exports.default = OfferWithEstimatesProduct;
